import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara'; // Assuming Lara is correctly imported and available
import { routes } from './app.routes';
import { authInterceptor } from './auth/auth.interceptor';
import { MessageService } from 'primeng/api';

// Override PrimeNG Lara preset to set primary brand color
const baseTheme: any = Lara as any;
const CustomLara: any = {
  ...baseTheme,
  semantic: {
    ...baseTheme?.semantic,
    colorScheme: {
      ...baseTheme?.semantic?.colorScheme,
      light: {
        ...baseTheme?.semantic?.colorScheme?.light,
        focusRing: {
          ...baseTheme?.semantic?.colorScheme?.light?.focusRing,
          shadow: '0 0 0 0.2rem #FCCFCC'
        },
        list: {
          ...baseTheme?.semantic?.colorScheme?.light?.list,
          option: {
            ...baseTheme?.semantic?.colorScheme?.light?.list?.option,
            // Hover/focus de opción en menús (Select, etc.)
            focusBackground: '#FCCFCC',
            // Seleccionado
            selectedBackground: '#E85B51',
            selectedFocusBackground: '#E85B51',
            selectedColor: '#ffffff',
            selectedFocusColor: '#ffffff'
          }
        },
        primary: {
          ...baseTheme?.semantic?.colorScheme?.light?.primary,
          color: '#E85B51',
          hoverColor: '#D94D49',
          activeColor: '#C0443F',
          contrastColor: '#ffffff'
        }
      }
    }
  }
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: CustomLara,
        options: {
          borderRadius: '0px',
          darkModeSelector: false
        }
      }
    }),
    MessageService
  ]
};
